const textColorSchemeLevel: { [key: string]: string } = {
  orange: '700',
  warning: '700',
  yellow: '800',
};
const baseStyle = ({ colorScheme }: Record<string, any>) => {
  return {
    bgColor: `${colorScheme}.50`,
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'full',
    _text: {
      fontWeight: 400,
      color: `${colorScheme}.${textColorSchemeLevel[colorScheme] ?? '500'}`,
    },
    _icon: {
      color: `${colorScheme}.${textColorSchemeLevel[colorScheme] ?? '500'}`,
    },
    _image: {
      borderRadius: 'full',
      alt: '--',
      _alt: {
        fontWeight: 600,
      },
      style: {
        height: '100%',
        width: '100%',
      },
    },
    _light: {
      borderColor: 'transparent',
    },
    _dark: {
      borderColor: 'transparent',
    },
  };
};

function getSize(size: any, fontSize: string, iconSize: any) {
  return {
    width: size,
    height: size,
    _text: {
      fontSize: fontSize,
      lineHeight: fontSize,
    },
    _icon: {
      size: iconSize,
    },
  };
}

const sizes = {
  'xs': getSize('6', 'xs', '3'),
  'sm': getSize('6', 'xs', '4'),
  'md': getSize('8', 'sm', '6'),
  'lg': getSize('12', 'lg', '8'),
  'xl': getSize('16', 'xl', '12'),
  '2xl': getSize('16', 'xl', '12'),
};

const defaultProps = {
  size: 'md',
  colorScheme: 'gray',
};

export default {
  baseStyle,
  sizes,
  defaultProps,
};
